export enum AuthorizationActions {
  RequestAuthorization = 'User wants to authorize to external service',
  AuthorizationRejected = 'Insufficient data for authorization',
  AuthorizationGranted = 'User authorized to external service for data',
  ResetPasswordEmail = 'Send reset password email',

  SignOffTheAccount = 'System signed off current session',
  FlushState = 'Flush whole state',

  TrySocialLogin = 'Try social login',
}

export enum UserAccountActions {
  RequestUserData = 'Request data about user account details',
  UserDataAccepted = 'Data for user account received successfully',
  UserDataRejected = 'Cannot fetch user account details from server',
  OpenCookies = 'User opened cookies policy',
  CloseCookies = 'User closed cookies policy',
  SaveCookies = 'Save cookies in API',
  SaveReservationFormSettings = 'Save reservation form settings in API',
  SwitchLanguage = 'User requested to switch language for user interface',
  LanguageSwitched = 'Language for user interface was changed',

  RequestLicenseData = 'Request user licence and integrations',
  LicenseDataAccepted = 'License data recived successfully',
  InvoiceLicenseDataAccepted = 'Invoice license data recived successfully',
  LicenseDataRejected = 'Cannot fetch user license from server',

  ToggleInfoModal = 'Toggle modal - user limit info',
  SaveUser = 'Save user in store',
  TryDeleteAccount = 'Try delete user account',
  ToggleDeleteError = 'toggle delete user account error',
  SetUserWorkerId = 'Set user worker id',
  RequestSubs = 'request user subscriptions',
  RequestCancelSub = 'request cancel user subscriptions',
  SubCancelled = 'user subscription cancelled',
}

export enum UpdatePasswordActions {
  UpdatePassword = 'Request to API about changing password for current logged in user',
  PasswordUpdated = 'Successfully changed password for current user',
  PasswordRejected = 'API rejected new password',
  ValidateOldPassword = 'Validate old password',
}

export enum LimitActions {
  ToggleLimitModal = 'toggle modal - limit',
  RequestLimits = 'request limits from API',
  LimitsWasAccepted = 'limits was accepted',
  SetSliderTab = 'Set slider tab',
}

export enum NotificationActions {
  LoadPage = 'Load notification page',
  Put = 'put notification',
  PageAccepted = 'Notification page accepted',
  MarkAsSeen = 'Mark notification(s) as seen',
  MarkAsSeenAll = 'Mark notification(s) as seen all',
  MarkAsRead = 'Mark notification(s) as read',
  Delete = 'Delete notification(s)',
  Reload = 'Reload notifications',
  SyncAccepted = 'Notification sync accepted',
  SendError = 'Send notification error message',
  ErrorSended = 'Notification error messagge sended succesfully',
}
